import { render, staticRenderFns } from "./showRowNumber-editor.vue?vue&type=template&id=3bf5a046&scoped=true&"
import script from "./showRowNumber-editor.vue?vue&type=script&lang=js&"
export * from "./showRowNumber-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf5a046",
  null
  
)

export default component.exports